import { Divider, Skeleton } from "antd";
import moment from "moment-timezone";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { updateOfferedCandidateProfile } from "../../pages/Profile/actions";
import { profileDataValidation, showErrorToast } from "../../utils/Functions";
import { ProfileCancelButton, ProfileSaveButton } from "./ProfileButtons";

const ExperienceDetail = ({
  experienceDetails,
  candidateId,
  isGuest,
  experiencedetails,
  setExperienceDetails,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.profile.loading);
  const [isEditExperienceDetails, setIsEditExperienceDetails] = useState(false);
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  let emptyDetails = [
    {
      occupation: "",
      company: "",
      summary: "",
      from: "",
      to: "",
    },
  ];

  useEffect(() => {
    if (!isGuest) {
      if (experienceDetails?.length > 0) {
        setExperienceDetails(experienceDetails);
      } else {
        experienceDetails = emptyDetails;
        setExperienceDetails(experienceDetails);
      }
    } else {
      setExperienceDetails(emptyDetails);
    }
  }, [experienceDetails]);
  /******************* 
  @Purpose : function for + functionality
  @Parameter : {}
  @Author : INIC
  ******************/
  const handleExeperienceAdd = (e) => {
    e.preventDefault();
    setExperienceDetails([
      ...experiencedetails,
      {
        occupation: "",
        company: "",
        summary: "",
        from: "",
        to: "",
      },
    ]);
  };
  /******************* 
   @Purpose : function for - functionality
   @Parameter : {}
   @Author : INIC
   ******************/
  const handleRemoveExperience = (index) => {
    const experienceValues = [...experiencedetails];
    experienceValues.splice(index, 1);
    setExperienceDetails(experienceValues);
  };
  /******************* 
   @Purpose : function to get the value
   @Parameter : {}
   @Author : INIC
   ******************/
  const handleExpDetail = (e, index, name) => {
    const expValues = [...experiencedetails];
    expValues[index][name] = e;
    setExperienceDetails(expValues);
  };
  const handleUpdate = async () => {
    if (validate()) {
      const payload = {
        id: candidateId,
        experiences: experiencedetails,
        modifiedBy: candidateId,
      };
      await dispatch(updateOfferedCandidateProfile(payload));
      setIsEditExperienceDetails(false);
    }
  };
  const validate = () => {
    let isFormValid = true;
    let errorList = [];
    experiencedetails.map((item, index) => {
      if (Object.keys(item).includes("occupation") && item.occupation === "") {
        errorList.push(item);
      } else {
        let obj = experiencedetails[index];
        if (
          obj.company === "" ||
          obj.summary === "" ||
          obj.from === "" ||
          obj.to === ""
        ) {
          errorList.push(obj);
        }
      }
    });
    isFormValid = errorList.length > 0 ? false : true;
    errorList.length > 0 && showErrorToast("Please fill the all details ");
    return isFormValid;
  };

  return (
    <>
      <Col sm={12} className="pt-4 mt-2 pb-4 mb-2">
        <div className="edit-details">
          <Divider orientation="left" orientationMargin="0" className="mb-0">
            <div className="title "> Experience Details</div>
          </Divider>

          {!isGuest && !isEditExperienceDetails && (
            <div className="edit-btn">
              <Button
                variant="warning btn-edit"
                size="sm"
                onClick={() => setIsEditExperienceDetails(true)}
              >
                <span className="bx bx-edit-alt"></span> Edit
              </Button>
            </div>
          )}
        </div>
      </Col>
      {loading && (
        <>
          <Col md={4} sm={6}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </Col>
          <Col md={4} sm={6}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </Col>
          <Col md={4} sm={6}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </Col>
          <Col md={12} sm={12}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </Col>
        </>
      )}
      {!loading && (
        <Fragment>
          {experiencedetails?.map((experienceDetail, index) => (
            <Row>
              <Col md={4} sm={6}>
                <div className="single-row-wrap form-group">
                  <small>Occupation/Title</small>
                  {!isGuest && !isEditExperienceDetails && (
                    <h6 className="mt-1 text-title">
                      {profileDataValidation(experienceDetail?.occupation)}
                    </h6>
                  )}
                  {(isGuest || isEditExperienceDetails) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={experienceDetail?.occupation}
                        onChange={(e) => {
                          const re = e.target.value.replace(
                            /[^a-z / " "]/gi,
                            ""
                          );
                          handleExpDetail(re, index, "occupation");
                        }}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col md={4} sm={6}>
                <div className="single-row-wrap form-group">
                  <small>Company</small>
                  {!isGuest && !isEditExperienceDetails && (
                    <h6 className="mt-1 text-title">
                      {profileDataValidation(experienceDetail?.company)}
                    </h6>
                  )}
                  {(isGuest || isEditExperienceDetails) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={experienceDetail?.company}
                        onChange={(e) => {
                          const re = e.target.value.replace(
                            /[^a-z / " "]/gi,
                            ""
                          );
                          handleExpDetail(re, index, "company");
                        }}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col md={4} sm={6}>
                <div className="single-row-wrap form-group">
                  <small>Summary</small>
                  {!isGuest && !isEditExperienceDetails && (
                    <h6 className="mt-1 text-title">
                      {profileDataValidation(experienceDetail?.summary)}
                    </h6>
                  )}
                  {(isGuest || isEditExperienceDetails) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={experienceDetail?.summary}
                        onChange={(e) =>
                          handleExpDetail(e.target.value, index, "summary")
                        }
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col sm={12}>
                <div className="single-row-wrap form-group">
                  <small>Work Duration</small>
                  {!isGuest && !isEditExperienceDetails && (
                    <h6 className="mt-1 text-title">
                      {profileDataValidation(experienceDetail?.from)}

                      {" - "}
                      {profileDataValidation(experienceDetail?.to)}
                    </h6>
                  )}
                  {(isGuest || isEditExperienceDetails) && (
                    <Row>
                      <Col sm={6}>
                        <DatePicker
                          placeholderText="From"
                          className="form-control"
                          value={experienceDetail?.from}
                          selected={endMonth}
                          onChange={(date) => {
                            let next = new Date(
                              date.getFullYear(),
                              date.getMonth(),
                              date.getDate(),
                              date.getHours() + 1
                            );
                            setEndMonth(next);
                            setStartMonth(
                              new Date(date).setMonth(date.getMonth() + 1)
                            );
                            handleExpDetail(
                              moment(next).format("MM/yyyy"),
                              index,
                              "from"
                            );
                          }}
                          selectsStart
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          maxDate={new Date()}
                        />
                      </Col>
                      <Col sm={6}>
                        <DatePicker
                          placeholderText="To"
                          className="form-control"
                          // disabled={i.isWorking ? true : false}
                          minDate={startMonth || new Date()}
                          selected={endMonth}
                          value={experienceDetail?.to}
                          onChange={(date) => {
                            let to = new Date(date);
                            setEndMonth(new Date(date));
                            handleExpDetail(
                              moment(to).format("MM/yyyy"),
                              index,
                              "to"
                            );
                          }}
                          selectsStart
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                        />
                      </Col>
                    </Row>
                  )}
                </div>
              </Col>
              {(isGuest || isEditExperienceDetails) && (
                <div className="edit-inline-action bottom-btns justify-content-end w-100">
                  {experiencedetails.length - 1 === index && (
                    <Button
                      variant="primary btn-icon btn-icon-add"
                      size="sm"
                      onClick={(e) => {
                        handleExeperienceAdd(e);
                      }}
                    >
                      <span className="bx bx-plus"></span>
                    </Button>
                  )}
                  {experiencedetails.length !== 1 && (
                    <Button
                      variant="secondary btn-icon btn-icon-remove"
                      size="sm"
                      onClick={() => handleRemoveExperience(index)}
                    >
                      <span className="bx bx-minus"></span>
                    </Button>
                  )}
                  {!isGuest && experiencedetails.length - 1 === index && (
                    <ProfileSaveButton onClick={() => handleUpdate()} />
                  )}
                  {!isGuest && experiencedetails.length - 1 === index && (
                    <ProfileCancelButton
                      onClick={() => {
                        setIsEditExperienceDetails(false);
                        if (experienceDetails?.length > 0) {
                          setExperienceDetails(experienceDetails);
                        } else {
                          setExperienceDetails(emptyDetails);
                        }
                      }}
                    />
                  )}
                </div>
              )}
            </Row>
          ))}
        </Fragment>
      )}
    </>
  );
};

export default ExperienceDetail;
